import withMention from './plugin.js';
import renderElemConf from './render-elem.js';
import elemToHtmlConf from './elem-to-html.js';
import parseHtmlConf from './parse-elem-html.js';
const module = {
  // JS 语法
  editorPlugin: withMention,
  renderElems: [renderElemConf],
  elemsToHtml: [elemToHtmlConf],
  parseElemsHtml: [parseHtmlConf]
};
export default module;
